import { useSession } from './useSession';

export const useIsSessionLoading = () => {
  const { state: sessionState } = useSession();
  const isLoading = sessionState.value === 'LOADING';

  return isLoading;
};
